import { store } from '@sonifi/wb-core/store/store';
import { setConfirmOpen } from '@sonifi/wb-notifier/store/notifierSlice';
import { CONFIRMS_IDS } from '../constants/notifierConstants';

export const initConfirm =
  ({ id = CONFIRMS_IDS.wbapp, buttons, content, title }) =>
  (dispatch) => {
    dispatch(setConfirmOpen({ id, buttons, content, title }));

    return new Promise((resolve) => {
      const unsubscribe = store.subscribe(() => {
        const state = store.getState();
        if (state.notifier.confirm[id].isConfirmed) {
          unsubscribe();
          resolve(true);
        }
        if (state.notifier.confirm[id].isDeclined) {
          unsubscribe();
          resolve(false);
        }
      });
    });
  };
